import $ from 'jquery'

export default selectTab => {
  var hash = location.hash
  if (hash) {
    let slctTab = hash.replace(/^#/, '')
    let slctAria = hash
    let $tablist = $('[role="tablist"]')
    let $tabArea = $(slctAria).parent()
    $tablist.find('button').attr('aria-selected', false)
    $('#tab-' + slctTab).attr('aria-selected', true)
    $tabArea.children('[role=tabpanel]').not(slctAria).attr('aria-hidden', true)
    $(slctAria).attr('aria-hidden', false)
  }
  $('[role=tab]').on('click', function (e) {
    e.preventDefault()
    let $this = $(this)
    let slctAria = '#' + $this.attr('aria-controls')
    location.hash = slctAria
    let $tablist = $this.parents('[role="tablist"]')
    let $tabArea = $(slctAria).parent()
    if ($(slctAria).length < 1) return false
    $tablist.find('button').attr('aria-selected', false)
    $this.attr('aria-selected', true)
    $tabArea.children('[role=tabpanel]').not(slctAria).attr('aria-hidden', true)
    $(slctAria).attr('aria-hidden', false)
  })
}



// WEBPACK FOOTER //
// ./src/assets/js/tab.js